"use stric";

import api from "./apiService.js";
import WithToken from "./tokenService";
import configuration from "./../../config.json";

const reprocessUnitsService = {
  getReprocessUnits: function () {
    return api.get("/ReprocessUnits", WithToken.headersToken({}, configuration.cookieName));
  },
  getReprocessUnitsTypes: function () {
    return api.get("/ReprocessUnits/Types", WithToken.headersToken({}, configuration.cookieName));
  },
  createReprocessUnit: function (options) {
    return api.post("/ReprocessUnits", options, WithToken.headersToken({}, configuration.cookieName));
  },
  deleteReprocessUnit: function (id) {
    return api.delete("/ReprocessUnits", WithToken.headersToken({ params: { id: id } }, configuration.cookieName));
  },
};

export default reprocessUnitsService;
